import cartFragment from '../fragments/cart'

const mutation = `mutation cartBuyerIdentityUpdate($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!) {
  cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {
    cart ${cartFragment}
    userErrors {
      field
      message
    }
  }
}`

export default mutation
